var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.164,
    height: 16.329,
    viewBox: "0 0 16.164 16.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attachment",
    "data-name": "Icon material-attachment",
    d: "M3,14.577A4.075,4.075,0,0,1,7.077,10.5h7.783a2.965,2.965,0,0,1,0,5.93H8.56a1.853,1.853,0,1,1,0-3.706h5.56v1.483H8.493c-.408,0-.408.741,0,.741h6.368a1.483,1.483,0,1,0,0-2.965H7.077a2.594,2.594,0,0,0,0,5.189h7.042v1.483H7.077A4.075,4.075,0,0,1,3,14.577Z",
    transform: "matrix(0.695, -0.719, 0.719, 0.695, -9.637, 5.529)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.aa95aa7c227082a530ef8c93bc4e9f0e.svg";
export { ForwardRef as ReactComponent };